/**
 * Brand Story Navigation Management
 * 
 * Part 1: When user clicks "Scrubstory" in header, redirect to last visited landing page
 * Part 2: When on brand-story page, save user's choice and replace history
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'scrubroom_last_landing';
  
  /**
   * PART 1: Intercept "Scrubstory" header clicks
   * Redirect to the last visited landing page instead of brand-story
   */
  function interceptScrubstoryClick(e) {
    const link = e.target.closest('a[href*="/pages/brand-story"]');
    
    if (!link) return;
    
    // Get the last visited landing page from localStorage
    const lastLanding = localStorage.getItem(STORAGE_KEY);
    
    if (lastLanding) {
      e.preventDefault();
      console.log('Redirecting to last landing page:', lastLanding);
      window.location.href = lastLanding;
    }
    // If no previous choice, let them go to brand-story (first time)
  }

  /**
   * PART 2: On brand-story page, handle shop clicks
   */
  function handleBrandStoryNavigation(e) {
    // Only run on brand-story page
    if (!window.location.pathname.includes('/pages/brand-story')) {
      return;
    }

    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href.includes('javascript:') || href.startsWith('#')) return;

    let landingPage = null;
    let landingTitle = null;

    // Detect women's links
    if (href.toLowerCase().includes('/women') || 
        link.textContent.toLowerCase().includes('women') ||
        link.textContent.toLowerCase().includes('shop women')) {
      
      landingPage = '/pages/women-home';
      landingTitle = 'Women\'s Scrubs - Scrub Room';
    } 
    // Detect men's links
    else if (href.toLowerCase().includes('/men') || 
             link.textContent.toLowerCase().includes('men') ||
             link.textContent.toLowerCase().includes('shop men')) {
      
      landingPage = '/pages/men-home';
      landingTitle = 'Men\'s Scrubs - Scrub Room';
    }

    if (landingPage) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('Saving landing page preference:', landingPage);
      
      // Save the user's choice
      localStorage.setItem(STORAGE_KEY, landingPage);
      
      // Replace brand-story in history with the landing page
      window.history.replaceState(
        { 
          page: landingPage,
          from: 'brand-story',
          timestamp: Date.now()
        },
        landingTitle,
        landingPage
      );
      
      // Navigate to destination
      window.location.href = href;
    }
  }

  // Attach both listeners
  document.addEventListener('click', interceptScrubstoryClick, true);
  document.addEventListener('click', handleBrandStoryNavigation, true);

  console.log('Brand Story Navigation: Active (Header + Page)');

})();